/**
 * 文档访问统计
 */
class DocAccessStatistics {
	Vue;
	// 一次登录中重复访问的文档不累计访问次数
	idSet = new Set();
	// 文档菜单对象，等待文档页面加载后由document-home赋值
	DocPageMenu;

	constructor(Vue) {
		this.Vue = Vue
	}

	get $lv() {
		return this.Vue.prototype.$lv
	}

	get $http() {
		return this.Vue.prototype.$http
	}

	/**
	 * 登录事件
	 */
	loginEvent() {

	}

	/**
	 * 打开文档事件
	 * @param menu 打开的菜单
	 * @param option 菜单外的参数
	 */
	async openDocEvent(menu, option) {
		if (!menu) {
			return;
		}
		if (menu.id && this.idSet.has(menu.id)) {
			return
		}
		if (!option) {
			option = {}
		}
		this.idSet.add(menu.id)
		const data = await this.$http.post('/nocode/nocode/accessStatistics/insert', {
			docPath: menu.path, // 文件路径
			docSys: this.DocPageMenu.title, // 系统
			docTitle: menu.title, // 文档标题
			docAuthor: menu.author, // 文档作者
			docIndex: menu.id, // 文档索引标识
			operation: option.op || 'open' // 操作类型
		}).catch(e => console.error('记录访问信息出错：' + e));

		if (!data || !data.success) {
			console.error('记录访问信息出错' + (!!data ? ('：' + data.result) : ''))
		}
	}

	/**
	 * 统计访问情况
	 * @author yrf
	 * @return {Promise<void>}
	 */
	async sumAccess(context) {
		const data = await this.$http.post('/nocode/nocode/accessStatistics/sumDocAccess', {docSys: this.DocPageMenu.title})
			.catch(e => context && context.$nav.error('统计访问数据出错：' + e));
		if (data.success) {
			return data.result;
		} else {
			context && context.$nav.error('统计访问数据出错：' + data.result);
			return [];
		}
	}

	/**
	 * 从后台获取文档被访问次数
	 * @author yrf
	 * @return {Promise<void>}
	 */
	async getPvCount(context) {
		const data = await this.$http.post('/nocode/nocode/accessStatistics/countDocAccessTimes', {docSys: this.DocPageMenu.title})
			.catch(e => context && context.$nav.error('统计文档查看次数数据出错：' + e));
		if (data.success) {
			return data.result;
		} else {
			context && context.$nav.error('统计文档查看次数数据出错：' + data.result);
			return []
		}
	}

	/**
	 * 统计每个人写的文章数量
	 * @author yrf
	 */
	countPageByAuthor() {
		const obj = {};
		const list = [];
		let unknownAuthor = 0;
		for (const key in this.DocPageMenu.idMaps) {
			const {author, category} = this.DocPageMenu.idMaps[key]
			if (author) {
				obj[author] = obj[author] ? obj[author] + 1 : 1;
			} else if (!category) {
				unknownAuthor++
			}
		}
		for (const key in obj) {
			list.push({
				author: key,
				count: obj[key]
			})
		}
		if (unknownAuthor > 0) {
			list.push({
				author: '',
				count: unknownAuthor
			});
		}
		list.sort((a, b) => b.count - a.count)
		return list;
	}
}

export {DocAccessStatistics}
